<template>
    <div>
        <!-- <heads></heads> -->
        <div class="wid1200">
            <div class="mart30" v-if="tabListIndex == 0 || tabListIndex == 1">
                <div class="font30 font600 padtb5">{{ detailObj.title }}</div>
                <div>
                    <el-link type="info" @click.native="toNext(index)">
                        成都写字楼出租</el-link>
                    <el-link type="info" @click.native="toList(detailObj.districtCode, 'qy')">
                        >{{ commonfun.returnRegion(detailObj.districtCode) }}写字楼</el-link>
                    <el-link type="info" @click.native="toList(index)">
                        >{{ commonfun.returnBussileList(detailObj.business) }}写字楼</el-link>
                    <el-link type="info" @click.native="toList(index)">
                        >{{ detailObj.dictName }}</el-link>
                    <el-link type="info"> >{{ detailObj.dictName }}出租房源</el-link>
                </div>
            </div>
            <el-row class="mart30">
                <el-col :span="12">
                    <div class="swiper-box" style="height: 550px" v-if="dataList.length > 0">
                        <!-- swiper1 -->
                        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
                            <swiper-slide v-for="(item, index) in dataList" :key="index">
                                <!-- style="width: 100px; height: 100px" -->
                                <!-- @click="getSrcList1(item,index)" -->
                                <img class="comp-intro-banner img100" v-if="item.imageType != 4" :src="item.url" alt="item.title" />
                                <video v-else class="comp-intro-banner img100" :src="item.url" controls="controls"></video>
                            </swiper-slide>
                            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                        </swiper>
                        <!-- swiper2 Thumbs -->
                        <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                            <swiper-slide v-for="(item, index) in dataList" :key="index" class="slide-1">
                                <template v-if="item.imageType != 4">
                                    <img class="swiperSmallImg" :src="item.url" alt="item.title" />
                                </template>
                                <template v-else>
                                    <div class="video-thumbnail">
                                        <img class="swiperSmallImg" :src="item.url + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'" alt="视频缩略图" />
                                        <i class="el-icon-video-play"></i>
                                    </div>
                                </template>
                            </swiper-slide>
                        </swiper>
                    </div>
                </el-col>
                <el-col :span="11" :offset="1" style="height: 450px; position: relative;" class="">
                    <div style="height: calc(100% - 100px);">
                        <div>
                            <span class="colred font40 font600">{{ detailObj.prices }}</span>
                            <span class="font14 col333">元/月</span>
                            <span class="font14 col333 padl100">参考单价：{{ detailObj.price }}元/m²/月</span>
                        </div>
                        <el-row class="textcenter borderf2">
                            <el-col :span="6">
                                <p class="font20 font600 col333 line30">
                                    {{ detailObj.area }}平米
                                </p>
                                <p class="font12 col999">建筑面积</p>
                            </el-col>
                            <el-col :span="6">
                                <p class="font20 font600 col333 line30">
                                    {{ commonfun.getDictLabel("dictRenovation", detailObj.renovation) }}
                                </p>
                                <p class="font12 col999">装修情况</p>
                            </el-col>
                            <el-col :span="6">
                                <p class="font20 font600 col333 line30">
                                    {{ detailObj.apartmentG }}
                                </p>
                                <p class="font12 col999">可容工位</p>
                            </el-col>
                        </el-row>
                        <div class="line40 ">
                            <span class="font14 font600 col333"><i class="el-icon-office-building"></i>楼盘名称</span>
                            <router-link :to="{
                                name: 'builsDetail',
                                query: { houseid: detailObj.dictId },
                            }">
                                <span class="font14 col333 padl40 titleHouer">{{
                                    detailObj.dictName
                                }}</span>
                            </router-link>
                        </div>
                        <div class="line40">
                            <span class="font14 font600 col333"><i class="el-icon-school"></i>所在楼层</span>
                            <span class="font14 col333 padl40">{{ detailObj.floor }}</span>
                        </div>
                        <div class="line40">
                            <span class="font14 font600 col333"><i class="el-icon-map-location"></i>所在地址</span>
                            <span class="font14 col333 padl40">{{ commonfun.returnRegion(detailObj.districtCode) }}-{{
                                commonfun.returnBussileList(detailObj.business)
                            }}{{ detailObj.address }}</span>
                        </div>
                        <div class="line40">
                            <span class="font14 font600 col333"><i class="el-icon-s-opportunity"></i>房源编号</span>
                            <span class="font14 col333 padl40">{{ "FY-" + detailObj.id }}</span>
                        </div>
                    </div>
                    <div class="callbox" style="position: absolute; bottom: 0; width: 100%;">
                        <el-row class="">
                            <el-col :span="4">
                                <img :src="detailObj.headUrl" class="icon64" alt="" />
                            </el-col>
                            <el-col :span="10" class="">
                                <div class="line30">
                                    <span class="font12 col999">房源顾问</span>
                                    <span class="font16 col333 font600">{{ detailObj.userName }}</span>
                                </div>
                                <div class="font14 col333">好评经纪人，熟悉本房特色</div>
                            </el-col>
                            <el-col :span="10">
                                <p class="font20 colred font600 italic line80">
                                    {{ detailObj.mobile }}
                                </p>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
            <el-row :class="[
                titleFixes == true ? 'isFixed mt0' : '',
                'width100 mart20 font16 col333 bgf5 line30 padtb5 textcenter',
            ]" style="background: #f5f5f5">
                <el-col :span="20">
                    <el-col :span="3" v-for="(item1, index) in tabList" :key="index" @click.native="changeTab(index)"><span :class="tabListIndex == index ? 'borb' : ''">{{
                        item1.name
                    }}</span></el-col>
                </el-col>
            </el-row>
            <div class="mart50">
                <el-row>
                    <el-col :span="17">
                        <div v-if="tabListIndex == 0">
                            <p class="colred font24 font600">房源基本信息</p>
                            <div class="col333 font20 font600 mart30">基本信息</div>
                            <el-row class="mart20">
                                <el-col :span="12">
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">房源格局:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                办公室({{ detailObj.apartmentB }}) 会议室({{ detailObj.apartmentH }}) 工位({{ detailObj.apartmentG }})
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <!-- <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">房源朝向:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel( "dictDirection", detailObj.direction )}}
                                            </span>
                                        </el-col>
                                    </el-row> -->
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">写字楼等级:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">{{ detailObj.olevel }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">房源状态:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("dictSituation", detailObj.situation) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">付款方式:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("dictTenanPay", detailObj.tenanPay) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <!-- <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">通上下水:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{  commonfun.getDictLabel( "houseWater", detailObj.situation ) }}
                                            </span>
                                        </el-col>
                                    </el-row> -->
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">空调:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("houseHeating", detailObj.situation) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">能否注册:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">能</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">物业费:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent"> {{ detailObj.propertyPrice }}元/㎡</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">入驻时间:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                <span class="msgcontent">
                                                    {{ commonfun.getDictLabel("houseInTime", detailObj.inTime) || '随时' }}
                                                </span>

                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="mart50" v-if="tabListIndex == 0 || tabListIndex == 1">
                            <div class="col333 font20 font600 mart30">配套设施</div>
                            <officeFacilities :list="detailObj.conf"></officeFacilities>
                            <!-- <div v-for="(it,index) in detailObj.conf" :key="index">{{commonfun.getDictLabel('dictConf',it)}}</div> -->
                        </div>
                        <!-- <div class="mart50" v-if="tabListIndex==0 || tabListIndex==2">
                            <el-row>
                                <el-col :span="12">
                                    <p class="colred font24 font600">经纪人带看反馈</p>
                                </el-col>
                                <el-col :span="12" class="textright">
                                    <span class="font12 col333">带看最多</span>
                                    <span class="font12 col999">最新</span>
                                </el-col>
                            </el-row>
                            <div class="dklist mart30">
                              
                                <el-row v-for="(item,index) in followArr" :key='index' class="padtb20">
                                    <el-col :span="3">
                                        <img :src="item.headUrl" class="icon56" alt />
                                    </el-col>
                                    <el-col :span="21">
                                        <el-row>
                                            <el-col :span="12" class="font16 col333">{{item.userName}}</el-col>
                                           
                                        </el-row>
                                        <div class="font14 col666 padtb5 line24 mart5">{{item.content}}</div>
                                        <el-row>
                                            <el-col :span="12" class="font12 col666">{{item.createDate}}</el-col>
                                            <el-col :span="12" class="font14 colred textright">
                                                
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="textcenter col999 font12" v-if="followNum=='已经到底啦'">{{followNum}}</div>
                            <div class="lookbtn" v-if="followNum!='已经到底啦'" @click="getFollow('2')">查看全部带看反馈</div>
                        </div> -->

                        <div class="mart50" v-if="tabListIndex == 0 || tabListIndex == 2">
                            <p class="colred font24 font600">房源图片</p>
                            <el-row class="mart30">
                                <el-col :span="12" v-for="(item, index) in filteredImages" :key="index" v-show="index < num">
                                    <div class="houseImg">
                                        <el-image class="detailimg" style="width: 100px; height: 100px" :src="item.url" :preview-src-list="getSrcList(index)">
                                        </el-image>
                                    </div>
                                </el-col>
                            </el-row>
                            <div style="text-align:center" v-if="filteredImages.length > 4">
                                <el-button @click="showMore" type="danger" style="width: 50%">{{ txt }}</el-button>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6" :offset="1" class="searchBar" id="searchBar">
                        <div :class="[searchBarFixed == true ? 'isFixed  mt40' : '', 'border1 pad10']">
                            <div class="font16 col333 line30 font600">咨询顾问</div>
                            <div v-for="(item, index) in AgentArr" :key="index" class="padtb10">
                                <div class="disinline headurl">
                                    <img :src="item.headUrl" class="icon36" alt />
                                </div>
                                <div class="disinline">
                                    <div class="font14 col000 font600">
                                        {{ item.userName }}
                                        <span class="font12 col999">房源顾问</span>
                                    </div>
                                    <div class="font12 padtb5 col666">好评经纪人</div>
                                    <div class="font12 colred">咨询热线：{{ item.mobile }}</div>
                                </div>
                            </div>
                            <div>
                                <entrust :paramsid="id" type="1"></entrust>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="mart50" ref="mapcontent" v-if="tabListIndex == 0 || tabListIndex == 3">
                    <p class="colred font24 font600">周边配套</p>
                    <bdmap class="mart30" :latitudeVal="detailObj.latitude" :dictName="detailObj.dictName"></bdmap>
                </div>
                <div class="mart50" v-if="tabListIndex == 0 || tabListIndex == 4">
                    <p class="colred font24 font600">为你推荐优质房源</p>
                    <el-row class="mart30">
                        <el-col :span="6" v-for="(item, index) in recommendList" :key="index">
                            <!-- <router-link :to="{name:'officemmdetail',query:{}}"> -->
                            <div class="wid95" @click="relond(item.id)">
                                <el-image v-if="item.imageUrl" :src="item.imageUrl" alt />
                                <el-image v-else src="http://img.sccshf.com/defaultimage1.png" />
                                <div class="font14 col000">{{ item.dictName }}</div>
                                <el-row class="line30">
                                    <el-col :span="14" class="font12 col999">
                                        {{ commonfun.returnRegion(item.districtCode) }}-{{ commonfun.returnBussileList(item.business) }}
                                    </el-col>
                                    <el-col :span="10" class="textright">
                                        <span class="font16 colred font600">{{ item.prices }}</span>
                                        <span class="font12 colred">万</span>
                                    </el-col>
                                </el-row>
                            </div>
                            <!-- </router-link> -->
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bdmap from "../../components/baiduMapView";
import "swiper/dist/css/swiper.css";
import officeFacilities from "../../components/officeFacilities";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import entrust from "../../components/entrust";
export default {
    name: "officemmDetail",
    data() {
        return {
            dialogVisible: false,

            time: "",
            id: "",
            type: "",
            // id:'',
            detailObj: {
                latitude: "",
            },
            dataList: [],
            BigImg: [],
            swiperOptionTop: {
                spaceBetween: 10,
                loop: true,
                loopedSlides: 5, //looped slides should be the same
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
            telFindHouse: "",
            swiperOptionThumbs: {
                spaceBetween: 10,
                slidesPerView: 4,
                touchRatio: 0.2,
                loop: true,
                loopedSlides: 5, //looped slides should be the same
                slideToClickedSlide: true,
            },
            tabList: [
                { name: "基本信息", id: "0" },
                // { name: "配套设施", id: "1" },
                // { name: "带看反馈", id: "2" },
                { name: "房源图片", id: "2" },
                { name: "周边配套", id: "3" },
                { name: "优房推荐", id: "4" },
            ],
            tabListIndex: 0,
            followparmas: {
                page: 1,
                limit: 10,
                orderField: "",
                order: "",
                id: "",
            },
            followArr: [],
            AgentArr: [],
            recommend: {
                page: 1,
                limit: 4,
                orderField: "",
                tenant_code: this.$store.state.tenantCode, //城市编码
                order: "",
                dictId: "",
            },
            recommendList: [],
            followNum: "暂无数据",
            searchBarFixed: false,
            titleFixes: false,
            isShow: true,
            txt: "显示全部",
            num: 4,
        };
    },

    components: {
        bdmap,
        swiper,
        swiperSlide,
        officeFacilities,
        entrust,
    },
    created() {
        //  console.log(this.$route.query.houseid)
        this.id = this.$route.query.houseid;
        this.followparmas.houseId = this.id;
        this.getDtail();
        this.getpageImage();
        this.getFollow("1");
        this.getAgent();
    },
    mounted() {
        this.$emit("getMenuId", 1);
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    computed: {
        filteredImages() {
            return this.dataList.filter(item => item.imageType !== 4);
        }
    },
    methods: {
        relond(id) {
            let routeUrl = this.$router.resolve({
                path: "/officeLeaseDetail",
                query: {
                    houseid: id,
                },
            });
            window.open(routeUrl.href, "_blank");
        },
        handleScroll() {
            var scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;

            if (scrollTop > 500) {
                this.searchBarFixed = true;
                this.titleFixes = true;
            } else {
                this.searchBarFixed = false;
                this.titleFixes = false;
                this.tabListIndex = 0;
            }
            if (this.tabListIndex == 0 || this.tabListIndex == 3) {
                var h = this.$refs.mapcontent.offsetTop;
                if (scrollTop > h && scrollTop < h + 300) {
                    this.searchBarFixed = false;
                }
            }
        },
        changeTab(id) {
            this.tabListIndex = id;
        },
        // 页面详情
        getDtail() {
            this.$get(this.$api.officeBuild.getLeaseOffice, { id: this.id })
                .then((res) => {
                    console.log("页面详情", res);
                    if (res.code == 0) {
                        this.detailObj = res.data;
                        console.log("latitude" + this.detailObj.latitude);
                        this.recommend.dictId = res.data.dictId;
                        this.detailObj.conf =
                            this.detailObj.conf != null
                                ? this.detailObj.conf.split(",")
                                : [];
                        this.recommendLeaseList();
                    }
                })
                .catch((err) => {
                    console.log("页面详情err", err);
                });
        },
        // 页面图片详情
        getpageImage() {
            this.$get(this.$api.officeBuild.pageImage, { id: this.id })
                .then((res) => {
                    console.log("页面图片详情", res);
                    if (res.code == 0) {
                        if (res.data.length > 0) {
                            this.dataList = res.data;
                        } else {
                            this.dataList.push({
                                url: "http://img.sccshf.com/defaultimage1.png",
                                url: "http://img.sccshf.com/defaultimage1.png",
                                url: "http://img.sccshf.com/defaultimage1.png",
                                url: "http://img.sccshf.com/defaultimage1.png",
                            });
                        }
                        this.$nextTick(() => {
                            const swiperTop = this.$refs.swiperTop.swiper;
                            const swiperThumbs = this.$refs.swiperThumbs.swiper;
                            swiperTop.controller.control = swiperThumbs;
                            swiperThumbs.controller.control = swiperTop;
                        });
                        this.dataList.forEach((item) => {
                            this.BigImg.push(item.url);
                        });
                    }
                })
                .catch((err) => {
                    console.log("页面详情err", err);
                });
        },
        getSrcList(index) {
            const imageUrls = this.filteredImages.map(item => item.url);
            return imageUrls.slice(index).concat(imageUrls.slice(0, index));
        },
        getSrcList1(item, index) {
            // return this.BigImg.slice(index).concat(this.BigImg.slice(0,index))
        },
        // 房源跟进
        getFollow(type) {
            console.log("type", type);
            if (type == 1) {
                this.followparmas.page = 1;
            } else {
                this.followparmas.page += 1;
            }
            this.$get(this.$api.officeBuild.pageFollow, this.followparmas)
                .then((res) => {
                    console.log("房源跟进", res);
                    if (res.code == 0) {
                        if (res.data.list.length > 0) {
                            this.followArr = this.followArr.concat(
                                this.followArr,
                                res.data.list
                            );
                            this.followNum = "";
                            console.log(this.followArr);
                        } else {
                            this.followNum = "已经到底啦";
                        }
                    }
                })
                .catch((err) => {
                    console.log("房源跟进err", err);
                });
        },
        // 经纪人
        getAgent() {
            this.$get(this.$api.officeBuild.getAgent, { houseId: this.id })
                .then((res) => {
                    console.log("经纪人", res);
                    if (res.code == 0) {
                        this.AgentArr = res.data;
                    }
                })
                .catch((err) => {
                    console.log("经纪人err", err);
                });
        },
        recommendLeaseList() {
            this.$get(this.$api.officeBuild.recommendLeaseList, this.recommend)
                .then((res) => {
                    console.log("推荐", res);
                    if (res.code == 0) {
                        this.recommendList = res.data.list;
                    }
                })
                .catch((err) => {
                    console.log("推荐err", err);
                });
        },
        toNext() {
            let routeUrl = this.$router.resolve({
                path: "/OfficebuildList",
            });
            window.open(routeUrl.href, "_blank");
        },
        toList(val, tab) {
            if (tab === "qy") {
                this.$router.push({
                    name: "OfficebuildList",
                    params: { qy: val },
                });
            } else {
                this.$router.push({
                    name: "OfficebuildList",
                    params: { sq: val },
                });
            }
        },
        showMore() {
            this.isShow = !this.isShow;
            this.num = this.isShow ? 4 : this.filteredImages.length;
            this.txt = this.isShow ? "显示全部" : "收起";
        },
    },
};
</script>

<style  lang="scss">
@import "office.scss";

.callbox {
    background: #fff;
    border-top: 1px solid #f2f2f2;
    padding: 15px 0 0 0;
}

.video-thumbnail {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    overflow: hidden;
    
    .swiperSmallImg {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
    }
    
    .el-icon-video-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 24px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        padding: 8px;
        z-index: 2;
    }
}

.gallery-thumbs .swiper-slide {
    height: 110px;
    overflow: hidden;
    border-radius: 8px;
}

.gallery-thumbs .swiperSmallImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

// 添加以下样式来自定义图片预览的背景
.el-image-viewer__mask {
    opacity: 1;
  background: rgba(0, 0, 0, 0.8) !important; // 使用 !important 来确保样式覆盖
}

</style>



// WEBPACK FOOTER //
// src/pages/office/officeLeaseDetail.vue